import axiosClient from "../axios/axiosClient";

export function getAccreditations() {
  return axiosClient.get("/accreditations");
}

export function getAccreditation(accreditionId) {
  return axiosClient.get(`/accreditations/${accreditionId}`);
}

export function createAccreditation(data) {
  return axiosClient.post("/accreditations", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export const updateAccreditation = (accreditionId, data) => {
  return axiosClient.post(`/accreditations/${accreditionId}`, data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

export function deleteAccreditation(accreditionId) {
  return axiosClient.delete(`/accreditations/${accreditionId}`);
}
